import { TabsNames } from 'enums/TabsNames';
import { makeAutoObservable } from 'mobx';

export class UiStore {
  isNavbarVisible: boolean;

  activeTab: TabsNames = TabsNames.BallTracking;

  constructor() {
    this.isNavbarVisible = true;
    makeAutoObservable(this);
  }

  setIsNavbarVisible = (visible: boolean): void => {
    this.isNavbarVisible = visible;
  };

  setActiveTab = (value: TabsNames): void => {
    this.activeTab = value;
  };
}
